'use client';
import WhatsApp from '@/app/_components/ui/icons/WhatsApp.svg';
import Sms from '@/app/_components/ui/icons/Sms.svg';
import Image from 'next/image';
import Link from 'next/link';
import { useChatContext } from '@/app/_providers/ChatContext';
import { useState } from 'react';
export default function SpContact() {
  const [iconColor, setIconColor] = useState('#1FC95E');
  const { isOpen, setIsOpen } = useChatContext();

  const handleHover = () => {
    setIconColor('#fff'); // Change "newIconName" to the desired icon name on hover
  };

  const handleUnhover = () => {
    setIconColor('#1FC95E'); // Restore the default icon name when not hovered
  };

  return (
    <>
      <div className="spContactWrap bg-white  rounded-sm mb-4 pb-6  px-4 md:pl-6    ">
        <div className="border  border-light-gray-150 p-4 rounded-md">
          <div className="flex ">
            <div className="expertImg">
              <Image
                src="/images/expert.jpg"
                width="60"
                height="60"
                alt={'expert barghchi'}
                className="rounded-full"
                loading="eager"
                fetchPriority="low"
              />
            </div>
            <div className="pr-2">
              <div className="text-sm  text-slate-900 font-bold relative">
                <span className="w-2.5 h-2.5 absolute top-1.5 right-0 bg-light-green rounded-full animate-circle"></span>
                <div className="pr-4"> گفتگو با کارشناسان</div>
              </div>
              <div className="text-xs text-slate-900 pt-2.5">
                استعلام قیمت کالا برای همکاران و کارفرمایان
              </div>
            </div>
          </div>
          <div className="flex mt-2 md:text-sm text-xs  -mx-2">
            <div className="w-1/2 px-2">
              <button
                onMouseEnter={handleHover}
                onMouseLeave={handleUnhover}
                onClick={() => setIsOpen(true)}
                className=" w-full border rounded-md border-light-green text-light-green hover:bg-light-green hover:text-white transition-all duration-200 flex   py-2 justify-center "
              >
                <WhatsApp fill={iconColor} />
                <span className=" whitespace-nowrap pr-2">گفتگوی سریع</span>
              </button>
            </div>
            <div className="w-1/2 px-2">
              <Link
                href="/page/enquiry"
                className=" w-full border border-gray-500 rounded-md flex py-2 justify-center hover:bg-color-primary hover:text-white hover:border-color-primary transition-all duration-200 "
                target="_blank"
              >
                <Sms />
                <span className=" whitespace-nowrap pr-2">ارسال لیست</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
